import React, {useEffect, useState, useContext} from 'react';
import Loader from "../../components/sales/Loader/loader";
import localization from "../../assets/localization/localization";
import Layout from "../../components/sales/layout/layout";
import { getProfile } from 'services/redux/auth/login/action';
const ssoLoginTesting = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isLoading, setIsLoading] = useState(false)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setIsLoading(true)
        if(localStorage.getItem('authenticated')){
            console.log(localStorage.getItem('authenticated'));
            localStorage.setItem('authenticated',true)
        }else{
            // const RNWebView =  window["ReactNativeWebView"];
            // console.log(RNWebView);
            // console.log("RNWebView");
            // if (RNWebView) {
            //     const contentStr = {
            //         event: "LOGOUT",
            //         data: null,
            //         os: "ANDROID",
            //     };
            
            //     RNWebView.postMessage(JSON.stringify(contentStr));
            //     localStorage.clear();
            //     sessionStorage.clear();
            //     setTimeout(() => {
            //     localStorage.clear();
            //     sessionStorage.clear();
            //     window.location.reload();
            //     }, 300);
            // }
        }
        window.addEventListener('initiated', () => {
            setTimeout(() => {
                getProfile();
                window.location.href = "/dashboard/pm-dashboard"
            }, 200)
        })
        // setIsLoading(false)
    }, [])
    return (
        <>
            <Layout
                title={"Login Testing"}
                isLoading={isLoading}
            >

            </Layout>
        </>
    )
}

export default ssoLoginTesting